import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 sm:py-32 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found | Suvikka" description="The page you are looking for could not be found. Explore Suvikka's fashion, beauty, jewellery and lifestyle collections." noindex />
      <p className="font-display text-7xl sm:text-8xl font-semibold text-[#6A1B29]">404</p>
      <h1 className="font-display text-2xl sm:text-3xl font-semibold text-stone-900 mt-4">This page took a wrong turn</h1>
      <p className="text-stone-500 mt-3">The page you're looking for doesn't exist or may have moved. Let's get you back to something beautiful.</p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
        <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 bg-[#6A1B29] hover:bg-[#501325] text-white font-semibold px-6 py-3 rounded-full transition-colors">
          <Home className="w-4 h-4" /> Back to Home
        </Link>
        <Link to="/products" data-testid="notfound-shop" className="inline-flex items-center gap-2 border border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white font-semibold px-6 py-3 rounded-full transition-colors">
          <Search className="w-4 h-4" /> Shop Products
        </Link>
      </div>
    </div>
  );
}
